import React from "react";
import { useRouteDirection } from "../../utils/RouteDirectionContext";
import { motion } from "framer-motion";
import SectionOne from "./SectionOne";
// import Posts from "./posts/Posts";

export default function News({ t, themeColor }) {
  const { direction, isInPage } = useRouteDirection();

  const firstVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1,
        delay: 0,
      },
    },
  };

  const containerVariants = {
    hidden: {
      x: direction === "right" ? "-100vw" : "100vw",
      position: "absolute",
    },
    visible: {
      x: 0,
      transition: {
        duration: 1,
        delay: 0,
      },
    },
    exit: {
      x: direction === "right" ? window.innerWidth : -window.innerWidth,
      transition: { duration: 1 },
      position: "absolute",
    },
  };
  return (
    <motion.div
      variants={!direction || isInPage ? firstVariants : containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="w-[100vw]"
    >
      <SectionOne t={t} />
      {/* <Posts t={t} themeColor={themeColor} /> */}
    </motion.div>
  );
}
